import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../common/widgets/Button';
import Carousel from '../../../../../common/widgets/Carousel';
import Icons from '../../../../../common/widgets/Icons';
import { parseProducts } from '../../../helpers';
import { ProductCardModel, ProductListModel } from '../../../models/Product';
import { resources } from '../../../resources/resources';
import ProductListItem from '../ProductListItem';

interface IProductsSlideShowProps {
  title: string;
  productList: ProductListModel[];
  showAsBrands?: boolean;
  action: () => void;
}

const ProductsSlideShow = (props: IProductsSlideShowProps) => {
  const { t: translate } = useTranslation();
  const { title, productList, showAsBrands, action } = props;

  const products = parseProducts(productList, showAsBrands);

  return (
    <section className="page-section mb-60">
      <h2 className="section-title">
        <span>{title}</span>
        <span className="see-all-action">
          <Button
            className="btn-link see-all-btn"
            icon={<Icons.ArrowButton />}
            onClick={action}
          >
            <span className="btn-text">{translate(resources.seeAll)}</span>
          </Button>
        </span>
      </h2>
      <div className="edn-carousel edn-carousel-dots no-dots-mobile carousel-gap-30 carousel-gap-md-20 carousel-gap-xxs-10">
        <Carousel
          dots={true}
          infinite={false}
          speed={500}
          slidesToShow={4}
          slidesToScroll={(products?.length ?? 0) <= 4 ? 1 : 4}
          arrows={false}
          loading={!productList}
          responsive={[
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: (products?.length ?? 0) <= 3 ? 1 : 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: (products?.length ?? 0) <= 2.5 ? 1 : 2.5,
              },
            },
            {
              breakpoint: 360,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: (products?.length ?? 0) <= 1.5 ? 1 : 1.5,
              },
            },
          ]}
        >
          {_.map(products, (product: ProductCardModel) => {
            return (
              <ProductListItem
                key={product.productId ?? product.brandId}
                product={product}
              />
            );
          })}
        </Carousel>
      </div>
    </section>
  );
};

export default ProductsSlideShow;
